import React, {Component} from 'react';
import AppSaveReturn from '../parts/AppSaveReturn';
import AppHeader from './AppHeader';

class FilterGenerateList extends Component {
    constructor(props) {
        super(props);
        let importedFilterOptions = [];

        if(localStorage.getItem(window.location.pathname.replace("/", "")) !== null){
            importedFilterOptions = localStorage.getItem(window.location.pathname.replace("/", "")).split("&").slice(0, -1);
        }

        this.state = {
            filterOptions: importedFilterOptions
        };
    }
    render(){
        const filtersOptions = this.props.filterOptions;
        const filterOptionsImages = this.props.filterOptionImages;

        const filterOptionList = filtersOptions.map((filterOption, index) => {
            const isSelectedFilter = this.state.filterOptions.includes(filterOption.option_name);
            return <li key={filterOption.id}><a href="#" onClick={onClickFilterOption.bind(this)} chosenoption={filterOption.option_name} className={isSelectedFilter ? 'selected' : ''}><div className="icon"><img src={filterOptionsImages[filterOption.didactic[0] ? filterOption.didactic[0].id-1 : index]} alt={"Icoon ".index}/></div> {filterOption.option_name}</a></li>;
        }  
        );

        function arrayRemove(arr, value) {
            return arr.filter(function(ele){
                return ele !== value;
            });
         }
         
        function onClickFilterOption(e){
            let filterOptions = [...this.state.filterOptions];
            let chosenOption = e.currentTarget.attributes['chosenOption'].value;

            if(!filterOptions.includes(chosenOption)){
                filterOptions.push(chosenOption);
                e.currentTarget.classList.add("selected");
            }else{
                filterOptions = arrayRemove(filterOptions, chosenOption);
                e.currentTarget.classList.remove("selected");
            }

            this.setState({filterOptions});
            console.log(filterOptions);
        }
        return(
            <div>
                <AppHeader leftButton='Back' titleText='Filter' rightButton='Reset' />
                <section className="title">
                    <h2>
                        {this.props.title}_
                    </h2>
                </section>
                <section className="filter">
                    <ul>{filterOptionList}</ul>
                </section>

                <AppSaveReturn filterValue={this.state.filterOptions} />
            </div>
        )
    }
}

export default FilterGenerateList;